import React, { createContext, useContext, useState } from 'react';
import { Alert } from '@mui/material';
import { NotificationWrapper } from './Notification.styles';
export type severity = 'error' | 'success' | 'info' | 'warning';

export type ShowMessageCalBack = (message: string, type: severity) => void;
interface NotificationContextProps {
  showMessage: (message: string, type: severity) => void;
}

const NotificationContext = createContext<NotificationContextProps | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState<severity>('error');

  const showMessage = (msg: string, type: severity) => {
    setMessage(msg);
    setSeverity(type);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setMessage('');
  };

  return (
    <NotificationContext.Provider value={{ showMessage }}>
      <>{children}</>
      <NotificationWrapper autoHideDuration={6000} open={open} onClose={handleClose}>
        <Alert icon={false} onClose={handleClose} variant="filled" severity={severity}>
          {message}
        </Alert>
      </NotificationWrapper>
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};
